import NotificacoesService from "../../services/NotificacoesService";

class NotificacoesManager {
  async obterNotificacoes() {
    let resultado = await NotificacoesService.obterNotificacoes().then(
      resposta => resposta && resposta.data
    );
    if (!resultado) return {};
    return resultado;
  }
  async registrarVisualizacaoNotificacoes() {
    return await NotificacoesService.registrarVisualizacaoNotificacoes(
      new  Date().toLocaleString() )
  }
}

export default new NotificacoesManager();